import React, { useContext, useEffect } from 'react'
import Topbar from '../components/topbar'
import Panel from '../components/panel'
import Table from '../components/table'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../contexts/AuthProvider'
import { DetailsContext } from '../contexts/DetailsContext'

const Dashboard = (props) => {
  const {
      dashboardSummary,
      setDashboardSummary,
      recentComplain,
      setRecentComplain,
      recentUsers,
      setRecentUsers
  } = useContext(DetailsContext)

  let columnsUsers = ['Name', 'Email', 'Phone', 'Gender', 'Country', 'Status', 'ID']
  let columnsTransaction = ['User', 'Type', 'EffectedUser', 'Status', 'Date Created', 'ID']
  props.setNavShow(true)
  function formatNumber(number) {
    return number.toLocaleString('en-US', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
    });
}

const {
  user,
  setUser,
  isLogged,
  setIsLogged,
  login,
  logout
} = useContext(AuthContext)

const navigate = useNavigate()
useEffect(() => {
  if (!isLogged) {
    navigate('/')
  }
}, [isLogged])
  return (
    <div style={{position: 'relative'}} className='w3-col l9 w3-right m9 s12 main'>
        <div className="w3-container">
          <div className="w3-row w3-left w3-padding-24">
            <p className="w3-large texxt-black bold margin-0">Welcome back</p>
          </div>
          <div className="w3-right flex-row w3-padding-24">
            <p className="w3-text-purple">
              Dashboard
            </p>
            <p className="w3-small padding-sm">
              <i class="fa-solid fa-angles-right"></i>
            </p>
            <p className="text-dark">Admin</p>

          </div>
        </div>
        <div className="w3-container">
          <div className="w3-row">
            <div className="w3-container w3-half">
              <Panel name='Total Users' icon='fa-solid fa-user' perc='4.6' value={dashboardSummary && dashboardSummary.totalUsers} color='blue'/>
            </div>
            <div className="w3-container w3-half">
              <Panel name='Daily Active' icon='fa-solid fa-user-tie' perc='4.6' value={dashboardSummary && dashboardSummary.activeUsers} color='pink'/>
            </div>
          </div>
          <div className="w3-row">
            <div className="w3-container w3-half">
              <Panel name='Total Revenue' icon='fa-solid fa-receipt' perc='4.6' value={`Kes ${dashboardSummary && formatNumber( dashboardSummary.totalRevenue)}`} color='green' />
            </div>
            <div className="w3-container w3-half">
              <Panel name='Total Costs' icon='fa-solid fa-percent' perc='4.6' value={`Kes ${dashboardSummary && formatNumber( dashboardSummary.totalCost)}`} color='blue'/>
            </div>
          </div>
          <div className="w3-row">
            <div className="w3-container w3-half">
              <Panel name='Total Profit' icon='fa-solid fa-coins' perc='4.6' value={`Kes ${dashboardSummary && formatNumber(dashboardSummary.totalProfit)}`} color='purple' />
            </div>
            <div className="w3-container w3-half">
              <Panel name='Verified Users' icon='fa-solid fa-user-secret' perc='4.6' value={dashboardSummary && dashboardSummary.verifiedUsers} color='yellow'/>
            </div>
          </div>
        </div>
        <div className="w3-container w3-padding">
          <Table name='Recent Users' columns={columnsUsers} data={recentUsers ? recentUsers : []} edit={false} summary={true}/>
        </div>
        <div className="w3-container w3-padding">
          <Table name='Recent Complaints' columns={columnsTransaction} data={recentComplain ? recentComplain : []} edit={false} summary={true}/>
        </div>

    </div>
  )
}

export default Dashboard